export default {
  en: {
    cost_estimator: {
      breakdown: {
        labels: {
          civil_costs: 'Civil costs',
          design_costs: 'Design costs',
          equipment_materials: 'Equipment and materials',
          monitoring_control: 'Monitoring / Control',
          installation_services: 'Installation services',
          intake_outfall: 'Intake / Outfall',
          legal_professional: 'Legal and professional',
          membranes: 'Membranes',
          permitting: 'Permitting',
          piping_high_grade_alloy: 'Piping, High-grade alloy',
          pressure_vessels: 'Pressure vessels',
          pretreatment: 'Pretreatment',
          pumps: 'Pumps',
          energy_recovery_devices: 'Energy Recovery Devices',
          total: 'Total',
          intakes: 'Intake / Outfall',
          thermal_fabrication: 'Thermal fabrication',
          parts: 'Parts',
          chemicals: 'Chemicals',
          labour: 'Labour',
          electrical_energy: 'Electrical energy',
          thermal_energy: 'Thermal energy',
          thermal_plant_high_grade_alloys: 'Thermal plant high grade alloys'
        }
      },
      water_price: {
        breakdown: {
          labels: {
            debt: 'Debt',
            equity: 'Equity',
            debt_service_and_amortisation: 'Debt service and amortisation',
            equity_yield_and_amortisation: 'Equity yield and amortisation',
            total_capital_cost_and_amortisation: 'Total capital cost and amortisation',
            total_variable_costs: 'Other variable costs',
            energy_costs: 'Energy costs',
            labour: 'Labour',
            overheads: 'Overheads',
            water_price: 'Water price'
          }
        }
      }
    },
    legacy_cost_estimator: {
      breakdown: {
        labels: {
          civil_costs: 'Civil costs',
          design_costs: 'Design costs',
          equipment_materials: 'Equipment and materials',
          installation_services: 'Installation services',
          intake_outfall: 'Intake / Outfall',
          legal_professional: 'Legal and professional',
          membranes: 'Membranes',
          permitting: 'Permitting',
          piping_high_grade_alloy: 'Piping, High-grade alloy',
          pressure_vessels: 'Pressure vessels',
          pretreatment: 'Pretreatment',
          pumps: 'Pumps',
          energy_recovery_devices: 'Energy Recovery Devices',
          total: 'Total',
          intakes: 'Intake / Outfall',
          thermal_fabrication: 'Thermal fabrication',
          parts: 'Parts',
          chemicals: 'Chemicals',
          labour: 'Labour',
          electrical_energy: 'Electrical energy',
          thermal_energy: 'Thermal energy',
          thermal_plant_high_grade_alloys: 'Thermal plant high grade alloys'
        }
      },
      water_price: {
        breakdown: {
          labels: {
            debt: 'Debt',
            equity: 'Equity',
            debt_service_and_amortisation: 'Debt service and amortisation',
            equity_yield_and_amortisation: 'Equity yield and amortisation',
            total_capital_cost_and_amortisation: 'Total capital cost and amortisation',
            energy_costs: 'Energy costs',
            total_variable_costs: 'Total variable costs',
            labour: 'Labour',
            overheads: 'Overheads',
            water_price: 'Water price'
          }
        }
      }
    }
  }
};
